import { SurveyBanner } from '@/components/SurveyBanner/SurveyBanner';

interface SurveyRouteWrapperProps {
    children: React.ReactNode;
}

export const SurveyRouteWrapper = ({ children }: SurveyRouteWrapperProps) => {
    return (
        <>
            <SurveyBanner />

            <div className={'pt-16'}>{children}</div>
        </>
    );
};
